<template>
  <div>
    <v-toolbar flat color class="text-center">
      <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
        {{ $t("Today") }}
      </v-btn>
      <v-btn fab text small color="grey darken-2" @click="prev">
        <v-icon small>mdi-chevron-right</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$refs.calendar">
        {{ $refs.calendar.title }}
      </v-toolbar-title>
      <v-btn fab text small color="grey darken-2" @click="next">
        <v-icon small>mdi-chevron-left</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
    </v-toolbar>
    <v-sheet height="800">
      <v-calendar
        ref="calendar"
        v-model="focus"
        :now="today"
        :value="today"
        :events="events"
        color="primary"
        type="week"
        :event-color="getEventColor"
        :class="locale == 'en' ? 'calendar-ltr' : 'calendar-rtl'"
      ></v-calendar>
      <!-- @click:event="showEvent" -->
      <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :activator="selectedElement"
        offset-x
      >
        <v-card color="grey lighten-4" min-width="350px" flat>
          <v-toolbar :color="selectedEvent.color" dark>
            <v-btn icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <span v-html="selectedEvent.details"></span>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="secondary" @click="selectedOpen = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-sheet>

    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
export default {
  name: "studentCalendarComponent",
  data() {
    return {
      events: [],
      valid: false,
      focus: "",
      today: new Date().toISOString().substr(0, 10),
      scheduleMessage: "",
      successMessage: "",

      selectedOpen: false,
      selectedElement: null,
      selectedEvent: {},

      totalHours: 0,
      startItems: [],
      endItems: [],
      end_time_only: "",
      start_time_only: "",
      selectedEventObject: {}
    };
  },
  methods: {
    dataUpdated(error, message) {
      if (error) {
        this.$refs.snack.sendErrorAlert(message);
      } else {
        this.$refs.snack.sendSuccessAlert(message);
        this.$emit("resetData");
      }
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getEventColor(event) {
      return event.color;
    },

    goNext() {
      if (this.valid == false) {
        this.validate();
      } else {
        if (
          parseInt(this.reserveObject.end.substring(0, 2)) >
          parseInt(this.reserveObject.start.substring(0, 2))
        ) {
          this.selectSubjectDialog = false;
          this.confirmReservationDialog = true;
          this.scheduleMessage = "";

          this.subjectName = this.subjectsNamesAndFees[
            this.reserveObject.subject_id
          ].name;
          this.hour_fees = this.subjectsNamesAndFees[
            this.reserveObject.subject_id
          ].hour_price;
          this.totalHours =
            parseInt(this.reserveObject.end.substring(0, 2)) -
            parseInt(this.reserveObject.start.substring(0, 2));
          this.subjectTotalFees = this.totalHours * this.hour_fees;
          this.website_fees = this.original_website_fees;
          this.website_fees = this.totalHours * this.website_fees;
        } else {
          this.scheduleMessage = this.$i18n.t("from_to_error_message");
        }
      }
    },
    goBack() {
      this.selectSubjectDialog = true;
      this.confirmReservationDialog = false;
    },
    getEvent() {
      this.$http
        .get(this.getApiUrl + "/student/schedule", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.events = response.data.data;
          }
        });
    }
  },
  mounted() {
    // this.$refs.calendar.scrollToTime("08:00");

    this.getEvent();
  }
};
</script>

<style lang="scss" scoped>
.v-dialog {
  overflow-x: hidden !important;
  .container {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .teacher-image {
    max-width: 100px;
    max-height: 100px;
    margin: 0 auto !important;
    border-radius: 50%;
  }
  .col-sm-6,
  .col-12,
  .col-sm-12 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .primary-btn {
    width: auto !important;
  }
}
</style>
